import { createBrowserHistory } from 'history';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';

const applicationInsightsReactPlugin = new ReactPlugin();

const browserHistory = createBrowserHistory({});

const applicationInsights = new ApplicationInsights({
    config: {

        connectionString: import.meta.env.VITE_APP_APPLICATION_INSIGHTS_CONNECTIONSTRING,
        extensions: [applicationInsightsReactPlugin],
        extensionConfig: {
            [applicationInsightsReactPlugin.identifier]: { history: browserHistory }
        },
        enableAutoRouteTracking: true,
        disableAjaxTracking: false,
        maxBatchInterval: 0,
        disableFetchTracking: false,
        autoTrackPageVisitTime: true,
        enableCorsCorrelation: true,
        samplingPercentage: 100,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        enableUnhandledPromiseRejectionTracking: true
    }
});

if (import.meta.env.VITE_APP_APPLICATION_INSIGHTS_CONNECTIONSTRING) {
    applicationInsights.loadAppInsights();
    applicationInsights.trackPageView();

    const telemetryInitializer = (envelope: ITelemetryItem) => {
        envelope.tags = envelope.tags ?? [];
        envelope.tags['ai.cloud.role'] = 'Wall Forming';
        envelope.tags['ai.cloud.roleInstance'] = 'Wall Forming';
    };

    applicationInsights.addTelemetryInitializer(telemetryInitializer);
}

export { applicationInsightsReactPlugin, applicationInsights };
